// extracted by mini-css-extract-plugin
export default {"header":"ChipSelect_header__4k3oV","count":"ChipSelect_count__khkqc","bulk":"ChipSelect_bulk__DECUZ","chips":"ChipSelect_chips__R2y-e","empty":"ChipSelect_empty__+hwYO"};